import React, { useMemo, useState } from "react";
import { View } from "../../../../../../components/Common/react-native-components";
import useFetchOnlineReviewByPropertiesData from "../../../../hooks/useFetchOnlineReviewByPropertiesData";
import { makeArrayOfObjectOutOfMetricsData } from "../../../../../../utils/transformChartsAndTableData";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts"
import useGetBarChartDataWithDropdownFilter from "../../../../hooks/useGetBarChartDataWithDropdownFilter";
import { Dropdown, Typography } from "@hmsexp/component-library";
import { dropdownStyling } from "../../styles";
import styles from "./style";
import Pagination from "../../../../../../components/Common/Pagination";
import { useSelector } from "react-redux";
import { parseFilters } from "../../../../../Filters/utils/fetchData";
import Loader from "./Loader";
import { FETCH_OVERVIEW_ONLINE_REVIEW_PROPERTIES_DRILL_DOWN_DATA_CAMPAIGN } from "../../../../actionTypes";

const OnlineReviewByPropertiesBarGraph = ({ selectedMetricOptions }) => {

    const color = "#5E68CB"
    const { applied_filter_values } = useSelector(e => e?.filterReducer);
    const [selectedMetric, setSelectedMetric] = useState(selectedMetricOptions?.[0]?.value);

    const updatedFilters = useMemo(() => {
        const filters = parseFilters(applied_filter_values);
        return {
            ...filters,
            filters: {
                ...filters.filters,
                additional_filters: {
                    ...filters.filters?.additional_filters,
                    feedback_source: [selectedMetric]
                }
            }
        };
    }, [applied_filter_values, selectedMetric]);

    const { data, onPageChange, isLoading, page, data_per_page, totalPages } = useFetchOnlineReviewByPropertiesData({
        pageType: FETCH_OVERVIEW_ONLINE_REVIEW_PROPERTIES_DRILL_DOWN_DATA_CAMPAIGN,
        customFilters: updatedFilters,
        skip: !selectedMetric
    });

    const jsonData = makeArrayOfObjectOutOfMetricsData(data)
    const selectedMetrixLabel = selectedMetricOptions?.find(e => e.value === selectedMetric)?.label;
    let { barChartData } = useGetBarChartDataWithDropdownFilter({
        data: jsonData, selectedMetric: "Total", selectedMetrixLabel
    })

    return (
        <View>
            <Typography
                textProps={{ style: { marginBottom: 5 } }}
                variant='button'
                color='primaryContentMedium'
                fontWeightType='regular'>
                Question
            </Typography>
            <View style={{ maxWidth: 200 }}>
                <Dropdown
                    items={selectedMetricOptions}
                    onChange={setSelectedMetric}
                    value={selectedMetric}
                    label={''}
                    style={{
                        container: {
                            ...dropdownStyling.container, width: 250, minWidth: 250
                        },
                        optionContainer: dropdownStyling.optionContainer,
                        dropDownText: dropdownStyling.dropDownText,
                        icon: dropdownStyling.icon
                    }}
                />
            </View>
            {isLoading ? <Loader /> : <>
                <HighchartsReact highcharts={Highcharts} options={barChartData} />
                <View style={{ flexDirection: 'row' }}>
                    <View style={[styles.selectedMetrixContainer, { borderColor: color }]}>
                        <View style={{ width: 10, height: 10, backgroundColor: color }}></View>
                        <Typography fontWeightType='regular' variant='button'>
                            {selectedMetrixLabel}
                        </Typography>
                    </View>
                </View>
            </>}
            <Pagination
                onPageChange={onPageChange}
                currentPage={page}
                pageSize={data_per_page}
                totalRecords={totalPages}
            />
        </View>
    );
};

export default OnlineReviewByPropertiesBarGraph; 